module.exports = __webpack_public_path__ + "media/images/tianhua_logo-ad16adc4.png";